import React, { createContext, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie"

export const GlobalContext = createContext()

export const GlobalProvider = props => {
  let navigate = useNavigate();

  const [login, setLogin] = useState({
        email : "",
        password : ""
  });

  const [signup, setSignup] = useState({
        name : "",
        image_url : "",
        email : "",
        password : "",
  });

  const [data, setData] = useState(null);

  //materi create data
  const [input, setInput] = useState(
    {
        title: "",
        job_description: "",
        job_qualification: "",
        job_type: "",
        job_tenure: "",
        job_status: "",
        company_name: "",
        company_image_url: "",
        company_city: "",
        salary_min: "",
        salary_max: "",
    }
)

//indikator
const [fetchStatus, setFetchStatus] = useState(true)

//indikator
const [currentId, setCurrentId] = useState(-1)

//handling input
const handleInput = (event) => {
    let name = event.target.name
    let value = event.target.value

    setInput({ ...input, [name]: value }) 
}

//handling submit
const handleSubmit = (event) => {
    event.preventDefault()
    console.log(input)

    let {
        title, 
        job_description, 
        job_qualification, 
        job_type,
        job_tenure, 
        job_status, 
        company_name, 
        company_image_url, 
        company_city, 
        salary_min, 
        salary_max
    } = input

    if (currentId === -1) {
        //create data
        axios.post('https://dev-example.sanbercloud.com/api/job-vacancy', 
        {
            title, 
            job_description, 
            job_qualification, 
            job_type,
            job_tenure, 
            job_status, 
            company_name, 
            company_image_url, 
            company_city, 
            salary_min, 
            salary_max
        },
        {headers: {"Authorization" : "Bearer "+ Cookies.get('token')}})
        .then((res) => {
            console.log(res)
            setFetchStatus(true)
            navigate('/dashboard')
        })
    } else {
        // update data
        axios.put(`https://dev-example.sanbercloud.com/api/job-vacancy/${currentId}`, 
        {
            title, 
            job_description, 
            job_qualification, 
            job_type,
            job_tenure, 
            job_status, 
            company_name, 
            company_image_url, 
            company_city, 
            salary_min, 
            salary_max
        },
        {headers: {"Authorization" : "Bearer "+ Cookies.get('token')}})
        .then((res) => {
            console.log(res)
            setFetchStatus(true)
            navigate('/dashboard')
        })
    }

    //balikin indikator ke -1
    setCurrentId(-1)

    //clear input setelah create data
    setInput(
        {
            title: "",
            job_description: "",
            job_qualification: "",
            job_type: "",
            job_tenure: "",
            job_status: "",
            company_name: "",
            company_image_url: "",
            company_city: "",
            salary_min: "",
            salary_max: "",
        }
    )
}

        // indikator loading
  const [display, setDisplay] = useState(null);

  const formatSizeUnits = (mb)=> {
    if (mb >= 1000)       { mb = (mb / 1000).toFixed(0) + " GB"; }
    else if (mb > 1)           { mb = mb + " mb"; }
    else if (mb === 1)          { mb = mb + " mb"; }
    else                          { mb = "0 mb"; }
    return mb;
  }

//   const truncateString = (str, num) => {
//     if (str != null && str.length > num) {
//         return str.slice(0, num) + "...";
//     } else {
//         return str;
//     }
// }

const formatRupiah = (angka, prefix) => {
    var number_string = angka.replace(/[^,\d]/g, '').toString(),
    split   		= number_string.split(','),
    sisa     		= split[0].length % 3,
    rupiah     		= split[0].substr(0, sisa),
    ribuan     		= split[0].substr(sisa).match(/\d{3}/gi);

    // tambahkan titik jika yang di input sudah menjadi angka ribuan
    if(ribuan){
        let separator = sisa ? '.' : '';
        rupiah += separator + ribuan.join('.');
    }

    rupiah = split[1] !== undefined ? rupiah + ',' + split[1] : rupiah;
    return prefix === undefined ? rupiah : (rupiah ? 'Rp. ' + rupiah : '');
}

  const truncateString = (string = '', maxLength = 100) => string.length > maxLength 
    ? `${string.substring(0, 30)}.…`: string

  //handle state function
  const fetchData = () => {
    axios
      .get(`https://dev-example.sanbercloud.com/api/job-vacancy`)
      .then((res) => {
        setDisplay(false);
        setData(res.data.data);
      })
      .catch((err) => {
        console.log(err);
        alert("error");
      });
  }
    //   console.log(data);

    const handleChange = (event) => {
        
      let value = event.target.value
      let name = event.target.name

      if(name === "email"){
        setLogin({...login, email : value})
      }else if(name === "password"){
        setLogin({...login, password : value})
      }
  }

  const handleChangeSignUp = (event) => {
        
    let value = event.target.value
    let name = event.target.name

    if(name === "name"){
      setSignup({...signup, name : value})
    }else if(name === "image_url"){
      setSignup({...signup, image_url : value})
    }else if(name === "email"){
      setSignup({...signup, email : value})
    }else if(name === "password"){
      setSignup({...signup, password : value})
    }
}

//   axios.post(`https://backendexample.sanbersy.com/api/data-contestant`,
//    {name: input.name},
//    {headers: {"Authorization" : "Bearer "+ Cookies.get('token')}}
// )
// .then(res => {
//     ....//logicnya
// })

  const handleLogin = (event) => {
    event.preventDefault()

    let {email, password} = login

    axios.post(`https://dev-example.sanbercloud.com/api/login`, {email, password})
    .then((res) => {
        let {token, user} = res.data
        Cookies.set('token', token, {expires : 1})
        Cookies.set('user', JSON.stringify(user), {expires : 1})
        navigate('/')
    })
    .catch((err) => {
        alert(err)
    })
}

const handleSignUp = (event) => {
    event.preventDefault()

    let {name, image_url, email, password} = signup
    axios.post(`https://dev-example.sanbercloud.com/api/register`, {name, image_url, email, password})
    .then((res) => {
        let {token, user} = res.data
        Cookies.set('token', token)
        Cookies.set('user', JSON.stringify(user))
        navigate('/')
    })
    .catch((err) => {
        alert(err)
    }
    )
}

  //handling delete
  const handleDelete = (event) => {
    let idData = parseInt(event.currentTarget.value)

    axios.delete(`https://dev-example.sanbercloud.com/api/job-vacancy/${idData}`,
        {headers: {"Authorization" : "Bearer "+ Cookies.get('token')}})
    .then((res) => {
        console.log(res)
        setFetchStatus(true)
    })
    .catch((error) => {
        alert(error)
    })
}

    //handling update
    const handleUpdate = (event) => {
      let idData = parseInt(event.currentTarget.value)
  
      setCurrentId(idData)
      navigate(`dashboard/list-job-vacancy/update/${idData}`)
  }
  
  //handle detail
  const handleDetail = (event) => {
    let idData = parseInt(event.currentTarget.value)

    setCurrentId(idData)
    navigate(`dashboard/list-job-vacancy/detail/${idData}`)
}

    //indikator

  let state = {
    login,
    setLogin,
    signup,
    setSignup,
    data,
    setData,
    input,
    truncateString,
    setInput,
    display,
    setDisplay,
    fetchStatus,
    setFetchStatus,
    formatSizeUnits,
    }

    let handleFunction = {
        fetchData,
        formatRupiah,
        handleChange,
        handleLogin,
        handleChangeSignUp,
        handleDetail,
        handleSignUp,
        handleInput,
        handleDelete,
        handleUpdate,
        handleSubmit,
    }


    return (
        <GlobalContext.Provider value={
            {
                state,
                handleFunction,
            }
        }>
            {props.children}
        </GlobalContext.Provider>
    )
}